<kendo-badge-container>
  <button kendoButton iconClass="fa-solid fa-message fa-lg" themeColor="secondary" fillMode="link"
    (click)="click()"></button>
  <kendo-badge [hidden]="!badge" size="small" [align]="badgeAlign" [themeColor]="modified ? 'info' : 'light'" [cutoutBorder]="true">
    {{badge}}
  </kendo-badge>
</kendo-badge-container>
